import { render, staticRenderFns } from "./EMelderComponentMeldenBs13Betreff.vue?vue&type=template&id=4106da2e"
import script from "./EMelderComponentMeldenBs13Betreff.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldenBs13Betreff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports